export default __webpack_public_path__ + "static/media/LogoVisitPorto&North_rbg_pos.2ba1d2d3.jpg";